import { render, staticRenderFns } from "./ManualIbaisProcessingRail.vue?vue&type=template&id=381bee17"
import script from "./ManualIbaisProcessingRail.vue?vue&type=script&lang=js"
export * from "./ManualIbaisProcessingRail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports